/**
 * Persistência mínima dos tokens JWT em localStorage.
 *
 * Encapsulamos por 2 motivos:
 *   1. Trocar pra cookie httpOnly no futuro = mudar SÓ aqui (sem caçar
 *      `localStorage.getItem` espalhado pelo código);
 *   2. SSR-safety — se um dia virar Next.js, `localStorage` não existe
 *      no server. As funções abaixo já fazem guard.
 *
 * Não exportamos a chave bruta — sempre via funções.
 */

const STORAGE_KEY = 'dynreport.tokens.v1';

export interface PersistedTokens {
  readonly accessToken: string;
  readonly refreshToken: string;
  readonly accessTokenExpiresAt: string;
  readonly refreshTokenExpiresAt: string;
}

export function readTokens(): PersistedTokens | null {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PersistedTokens;
  } catch {
    return null;
  }
}

export function writeTokens(tokens: PersistedTokens): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
}

export function clearTokens(): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(STORAGE_KEY);
}
